// extracted by mini-css-extract-plugin
export var deleteIcon = "_rv-5";
export var deleteOption = "_rv-3";
export var divider = "_rv-2";
export var downloadIcon = "_rv-4";
export var drawer = "_rv-0";
export var drawerFooter = "_rv-6";
export var drawerOpen = "_rv-1";
export var highlighted = "_rv-7";
export var lighterHighlight = "_rv-8";